import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-monitor",
  "use": "icon-monitor-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-monitor\"><defs><style type=\"text/css\">@font-face { font-family: rbicon; src: url(\"chrome-extension://dipiagiiohfljcicegpgffpbnjmgjcnf/fonts/rbicon.woff2\") format(\"woff2\"); font-weight: normal; font-style: normal; }\r\n</style></defs><path d=\"M64 64V640H896V64H64zM0 0h960v704H0V0z\" p-id=\"4696\" /><path d=\"M192 896H768v64H192zM448 640H512v256h-64z\" p-id=\"4697\" /><path d=\"M479.232 561.604267l309.9904-348.330667-47.803733-42.5472-259.566934 291.669333L303.957333 240.008533 163.208533 438.6048l52.224 37.009067 91.6224-129.28z\" p-id=\"4698\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/monitor.svg
// module id = Lu+8
// module chunks = 138